import React from 'react';

import './CoursesOverview.scss';
import sendEvent from '../../helpers/tracking';
import { isExternalLink } from '../../helpers/link';
import icons from '../../shared/assets/icons/redesign';

const { Check } = icons;

export default function CoursesOverview({
  NextLink, tracking, showEmailPopup
}) {
  return (
    <div className="_coursesOverview">
      <ul className="_coursesOverview-list">
        {[
          '10 populairste zwangerschaps- en bevalcursussen',
          'Gratis afhankelijk van je aanvullende verzekering',
          '18 maanden onbeperkt toegang voor €99,99',
          'Direct toegang vanuit je zorg Dashboard'
        ].map((item, idx) => {
          return (
            <li key={idx} className="_coursesOverview-list-item">
              <span className="_coursesOverview-icon-wrap">
                <Check className="_coursesOverview-icon" />
              </span>

              <p className="_coursesOverview-list-item-value">
                {item}
              </p>
            </li>
          );
        })}
      </ul>

      <div className="_coursesOverview-buttons-wrap">
        <NextLink href="/10-zwangerschaps-en-bevalcursussen-onbeperkt-en-online-bij-zwangerenportaalnl">
          <button
            onClick={() => sendEvent(...tracking.meerInformatie)}
            className="_coursesOverview-button-secondary">
            Meer informatie
          </button>
        </NextLink>

        <button
          onClick={() => (sendEvent(...tracking.bestellen),
            showEmailPopup(true))}
          className="_coursesOverview-button-primary">
          Bestellen
        </button>
      </div>
    </div>
  );
}
